<template>
    <div class="col-md-12">
        <div class="card panel panel-default actions">
            <div class="card-block">
                <div class="header-block d-flex justify-content-between align-items-center">
                    <h3>Workflows</h3>
                    <button v-if="canManageWorkflow" class="btn btn-primary pull-right" data-toggle="collapse" data-target="#create_workflow">
                        Create
                    </button>
                </div>

                <create-workflow-form v-if="canManageWorkflow"></create-workflow-form>
            </div>
        </div>
        <workflows-listing></workflows-listing>
    </div>
</template>
<script>
import CreateWorkflowForm from './create-workflow-form.vue';
import WorkflowsListing from './workflows-listing.vue';

export default {
    name: "workflows-index",
    components: {
        "create-workflow-form": CreateWorkflowForm,
        "workflows-listing": WorkflowsListing,
    },
    computed: {
        canManageWorkflow: function() {
            return this.$root.enabledPermissions.includes('manage_workflow')
        }
    }
}
</script>